<template>
  <ContentSection spacing="none">
    <div class="w-full">
      <ClientOnly>
        <Swiper
          class="relative items-stretch"
          :loop="true"
          :modules="[SwiperAutoplay]"
          :autoplay="{
            delay: data.swipe_interval ?? 8000,
            disableOnInteraction: true,
          }"
        >
          <SwiperSlide
            v-for="sliderItem in data.slider"
            :key="sliderItem.id"
            class="flex"
            :style="{
              'background-color': sliderItem.background_color ?? '',
            }"
          >
            <div
              :class="[
                orientation === 'left' ? 'flex flex-row' : 'flex flex-col',
              ]"
            >
              <AppImage
                v-if="sliderItem.image"
                :asset="sliderItem.image"
                class="h-screen max-h-[40vh] w-full object-cover"
                :class="[
                  orientation === 'left' ? 'order-2 w-2/3 lg:w-3/5' : 'order-1',
                ]"
              />
              <Container
                v-if="sliderItem.text"
                class="grow"
                :indent="orientation === 'left' ? 'none' : 'center'"
                :class="[
                  orientation === 'left'
                    ? 'order-1 flex w-3/5 shrink-0 items-center justify-center overflow-hidden px-10 lg:w-2/5'
                    : 'order-2',
                ]"
              >
                <Bard
                  v-if="sliderItem.text"
                  :content="sliderItem.text"
                  class="text-pretty py-5 text-center text-base font-normal"
                />
              </Container>
            </div>
          </SwiperSlide>
        </Swiper>
      </ClientOnly>
    </div>
  </ContentSection>
</template>

<script setup lang="ts">
import { type AssetFragment } from '#gql'
import tailwindBreakpoints from '~/utils/tailwindBreakpoints'

const props = defineProps<{
  data: {
    text_orientation: { value: 'left' | 'bottom' }
    swipe_interval: number
    slider: Array<{
      id: number
      text: string
      background_color: { value: string }
      image: AssetFragment
    }>
  }
}>()

const { smaller } = useBreakpoints(tailwindBreakpoints)
const orientation = computed(() => {
  if (smaller('md').value) {
    return 'bottom'
  }
  return props.data.text_orientation.value
})
</script>
